import React, { useContext } from "react"
import VerticalLayout from "../VerticalLayout/index"
import TableList from "../TableList/TableListUsers"
import { UserListContext } from "./UserListContext"

const UserListSection = () => {
  const UserListModel = useContext(UserListContext)
  const {
    UserTableTitle,
    userData,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
  } = UserListModel

  return (
    <VerticalLayout>
      <div style={{ marginTop: "70px" }}>
        <TableList
          navLocation={"details/userId?="}
          title={"Users List"}
          titleList={UserTableTitle?.titles}
          tableData={userData}
          nextPage={nextPage}
          totalPagesCount={totalPagesCount}
          pageNumberThreshold={pageNumberThreshold}
        />
      </div>
    </VerticalLayout>
  )
}

export default UserListSection
